import { render } from "./AButton.vue?vue&type=template&id=5754a856&scoped=true"
import script from "./AButton.vue?vue&type=script&lang=js"
export * from "./AButton.vue?vue&type=script&lang=js"

import "./AButton.vue?vue&type=style&index=0&id=5754a856&scoped=true&lang=scss"

import exportComponent from "/home/ben/work/acon/acon-360/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5754a856"]])

export default __exports__